<section class="jumbotron text-center my-4">
  <h1 class="jumbotron-heading">SET DE TELEVISIÓN UTPL</h1>
  <h6>Espacio virtual diseñado para interactuar con las funcionalidades del set de televisión.
  </h6>
</section>    
<section class="jumbotron text-center my-4 section1">
<div class="container">
  <div class="container">
    <h6 class="jumbotron-heading" class="style6"><b>Objetivo general:</b> &nbsp;virtualización del set de televisión UTPL con la finalidad de que los estudiantes realicen sus prácticas y se familiaricen con todas las funcionalidades disponibles.</h6>
  </div>
  <div class="row background1" >
    <div class="padding1"> 
    <section>
      <section class="padding3">
        <div class="row" >
          <div class="col-lg-4 col-md-12 mb-4 mb-lg-0">
            <div
              class="bg-image hover-overlay ripple shadow-1-strong rounded" data-ripple-color="light">
              <img src="/assets/img/1.png" class="w-100"/>
              <a href="#!" data-mdb-toggle="modal" data-mdb-target="#exampleModal1">
                <div class="mask" style="background-color: rgba(251, 251, 251, 0.2);"></div>
              </a>
            </div>
          </div>
          <div class="col-lg-4 mb-4 mb-lg-0">
            <div class="bg-image hover-overlay ripple shadow-1-strong rounded" data-ripple-color="light">
              <img src="/assets/img/2.png" class="w-100"/>
              <a href="#!" data-mdb-toggle="modal" data-mdb-target="#exampleModal2">
                <div class="mask" style="background-color: rgba(251, 251, 251, 0.2);"></div>
              </a>
            </div>
          </div>
          <div class="col-lg-4 mb-4 mb-lg-0">
            <div class="bg-image hover-overlay ripple shadow-1-strong rounded" data-ripple-color="light">
              <img src="/assets/img/3.png" class="w-100"/>
              <a href="#!" data-mdb-toggle="modal" data-mdb-target="#exampleModal3">
                <div class="mask" style="background-color: rgba(251, 251, 251, 0.2);"></div>
              </a>
            </div>
          </div>
        </div>
      </section>
      <section>
        <div class="row">
          <div class="col-lg-4 col-md-12 mb-4 mb-lg-0">
            <div
              class="bg-image hover-overlay ripple shadow-1-strong rounded" data-ripple-color="light">
              <img src="/assets/img/4.png" class="w-100"/>
              <a href="#!" data-mdb-toggle="modal" data-mdb-target="#exampleModal1">
                <div class="mask" style="background-color: rgba(251, 251, 251, 0.2);"></div>
              </a>
            </div>
          </div>
          <div class="col-lg-4 mb-4 mb-lg-0">
            <div class="bg-image hover-overlay ripple shadow-1-strong rounded" data-ripple-color="light">
              <img src="/assets/img/5.png" class="w-100"/>
              <a href="#!" data-mdb-toggle="modal" data-mdb-target="#exampleModal2">
                <div class="mask" style="background-color: rgba(251, 251, 251, 0.2);"></div>
              </a>
            </div>
          </div>
          <div class="col-lg-4 mb-4 mb-lg-0">
            <div class="bg-image hover-overlay ripple shadow-1-strong rounded" data-ripple-color="light">
              <img src="/assets/img/6.png" class="w-100"/>
              <a href="#!" data-mdb-toggle="modal" data-mdb-target="#exampleModal3">
                <div class="mask" style="background-color: rgba(251, 251, 251, 0.2);"></div>
              </a>
            </div>
          </div>
        </div>
       <!--  <div class="container">
          <div class="row">
            <div class="style1">
              <div class="content">
                <p class="margin1">
                  <a mat-raised-button class="btn btn-primary my-2" target="_blank" href="https://innovaciondocente.utpl.edu.ec/innovation/type/proyecto-innovacion/project-detail/Ib6id6Oy2m9Wuwb5PEZS">
                    ¡Conoce la propuesta!
                  </a>
                </p>
              </div>
          </div>
          </div>  
        </div>       -->      
      </section>
    </section>
  </div>
  </div> 
</div>
</section>
<section class="jumbotron text-center my-4">
<div class="container  mt-4" class="style2">
  <div>
    <div class="row">
      <div class="col-12 text-center">
        <div class="section-title mb-4 pb-2">
          <h1 class="jumbotron-heading">¡Conoce sobre nuestro set de televisión virtualizado!</h1>
          <h5 class="jumbotron-heading">Observa el video introductorio y luego descarga el instalador de la aplicación, instálala y experimenta por ti mismo.</h5>
          <h3 class="jumbotron-heading">¡Te sorprenderás!</h3>
        </div>
      </div>
    </div>
  </div>
  <div>
    <section class="jumbotron text-center my-2 style3">
      <div class="container mt-4">
        <div class="row">
          <div class="col-12 text-center">
            <div class="section-title mb-4 pb-8">
              <iframe width="50%" height="350" src="https://www.youtube.com/embed/k0mDKGswqYo" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
            </div>
          </div>
        </div>
      </div>
    </section>
    &nbsp;&nbsp;
    <div>
      <div class="row">
        <div class="col-12 text-center" style="background:#fff">
          <div class="section-title">
            <h2 class="jumbotron-heading">¡Descarga los aplicativos y experimenta por ti mismo!</h2>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-12 text-center" style="background:#fff">
          <div class="section-title mb-4 pb-12">
            <a class="btn btn-dark margin1" href="/assets/SetTV_Introductorio.exe"
            target="_blank"
            download="SetTV_Introductorio.exe"
            >Set TV Introductorio ( S.O. Windows <img width="20px" src="/assets/img/windows.png"/> )</a>&nbsp;
            <a class="btn btn-dark margin3" href="/assets/SetTV_Gamificado.exe"
            target="_blank"
            download="SetTV_Gamificado.exe"
            >Set TV Gamificado ( S.O. Windows <img width="20px" src="/assets/img/windows.png"/> )</a>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
</section>  
<section class="jumbotron text-center my-2 style3">
<div class="container  mt-4">
  <div class="row">
    <div class="col-12 text-center">
      <div class="section-title mb-4 pb-2">
        <h1 class="jumbotron-heading"><span class="style4"> Equipo docente</span></h1>
      </div>
    </div>
  </div>
</div>
<div  class="py-2 team4">
  <div  class="container">
    <div class="row justify-content-center">
      <div class="col-lg-4 mb-4">
        <div class="card">
          <div class="row text-center">
            <div class="col-md-12">
              <img class="card-img-top"
              src="/assets/img/Juan_Carlos_Maldonado_Vivanco.jpg"
              alt="Card image cap">
            </div>
            <div class="card-body">
              <h5 class="card-title">JUAN CARLOS MALDONADO VIVANCO</h5><hr />
              <h6>Docente investigador UTPL</h6>
            </div>
          </div>
        </div>
      </div>
      <div class="col-lg-4 mb-4">
        <div class="card">
          <div class="row text-center">
            <div class="col-md-12">
              <img class="card-img-top" 
              src="/assets/img/Milenny_Suquilanda.png"
                alt="Card image cap">
            </div>
            <div class="card-body">
              <h5 class="card-title">MILENNY SUQUILANDA</h5><hr />
              <h6>Docente investigador UTPL</h6>
            </div>
          </div>
        </div>
      </div>
      <div class="col-lg-4 mb-4">
        <div class="card">
          <div class="row text-center">
            <div class="col-md-12">
              <img class="card-img-top" 
              src="/assets/img/Carlos_Ortiz_Leon.jpg"
                alt="Card image cap">
            </div>
            <div class="card-body">
              <h5 class="card-title">CARLOS ORTÍZ LEÓN</h5><hr />
              <h6>Docente investigador UTPL</h6>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row justify-content-center">
      <div class="col-lg-4 mb-4">
        <div class="card">
          <div class="row text-center">
            <div class="col-md-12">
              <img class="card-img-top"
              src="/assets/img/Ana_Maria_Beltran_Flandoli.jpg"
              alt="Card image cap">
            </div>
            <div class="card-body">
              <h5 class="card-title">ANA MARÍA BELTRÁN FLÁNDOLI</h5><hr />
              <h6>Docente investigador UTPL</h6>
            </div>
          </div>
        </div>
      </div>
      <div class="col-lg-4 mb-4">
        <div class="card">
          <div class="row text-center">
            <div class="col-md-12">
              <img class="card-img-top" 
              src="/assets/img/Jhoana_Raquel_ Cordova.jpg"
                alt="Card image cap">
            </div>
            <div class="card-body">
              <h5 class="card-title">JHOANA RAQUEL CÓRDOVA</h5><hr />
              <h6>Docente investigador UTPL</h6>
            </div>
          </div>
        </div>
      </div>
      <div class="col-lg-4 mb-4">
        <div class="card">
          <div class="row text-center">
            <div class="col-md-12">
              <img class="card-img-top" 
              src="/assets/img/Martha_Vanessa_Agila_Palacios.jpg"
                alt="Card image cap">
            </div>
            <div class="card-body">
              <h5 class="card-title">MARTHA VANESSA AGILA PALACIOS</h5><hr />
              <h6>Docente investigador UTPL</h6>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
</section>
<div  class="py-2 team4 background">
<div class="width1">
  <div  class="row justify-content-center mb-4">
    <div  class="col-md-12 text-center">
      <h1  class="mb-4">Soporte tecnológico</h1>
        <h6>
          Trabajo conjunto entre el Club de Realidad Virtual y la Dirección de Tecnologías para la Educación.
        </h6>
    </div>
  </div>
  <div class="row justify-content-center" style="padding-left:1%">
    <div class="col-lg-2 mb-4">
      <div class="row text-center">
        <div class="col-md-12">
          <img src="/assets/img/Victor_Martinez.jpg" alt="wrapkit" class="img-fluid rounded-circle">
        </div>
        <div  class="col-md-12 text-center">
          <div  class="pt-2">
            <h5  class="mt-4 font-weight-medium mb-0">Víctor Martínez</h5>
            <h6  class="subtitle mb-3">DESARROLLO UNITY<br/>DISEÑO 3D</h6>
          </div>
        </div>
      </div>
    </div>
    <div  class="col-lg-2 mb-4">
      <div  class="row text-center">
        <div  class="col-md-12">
          <img src="/assets/img/Byron_Galvez.jpg" alt="wrapkit" class="img-fluid rounded-circle">
        </div>
        <div  class="col-md-12 text-center">
          <div  class="pt-2">
            <h5  class="mt-4 font-weight-medium mb-0">Byron Gálvez</h5>
            <h6  class="subtitle mb-3">DISEÑO GRÁFICO</h6>
          </div>
        </div>
      </div>
    </div>
    <div  class="col-lg-2 mb-4">
      <div  class="row text-center">
        <div  class="col-md-12">
          <img src="/assets/img/SAMANIEGO_FRANCO_JENNIFER_BETZABE.jpg" alt="wrapkit" class="img-fluid rounded-circle">
        </div>
        <div  class="col-md-12 text-center">
          <div  class="pt-2">
            <h5  class="mt-4 font-weight-medium mb-0">Jennifer Samaniego</h5>
            <h6  class="subtitle mb-3">COORDINACIÓN DEL PROYECTO</h6>
          </div>
        </div>
      </div>
    </div>
    <div  class="col-lg-2 mb-4">
      <div  class="row text-center">
        <div  class="col-md-12">
          <img src="/assets/img/Marlon_Carrion.jpg" alt="wrapkit" class="img-fluid rounded-circle">
        </div>
        <div  class="col-md-12 text-center">
          <div  class="pt-2">
            <h5  class="mt-4 font-weight-medium mb-0">Marlon Carrión</h5>
            <h6  class="subtitle mb-3">COORDINACIÓN DEL PROYECTO</h6>
          </div>
        </div>
      </div>
    </div>
    <div  class="col-lg-2 mb-4">
      <div  class="row text-center">
        <div  class="col-md-12">
          <img src="/assets/img/ROMERO_PARRA_ALEX_FERNANDO.jpg" alt="wrapkit" class="img-fluid rounded-circle">
        </div>
        <div  class="col-md-12 text-center">
          <div  class="pt-2">
            <h5  class="mt-4 font-weight-medium mb-0">Alex Romero</h5>
            <h6  class="subtitle mb-3">DESARROLLO ANGULAR</h6>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
</div>
<footer>
<div class="text-center p-3">
  © 2022 Copyright:
  <a class="text-dark" href="https://utpl.edu.ec/">UTPL</a>
</div>
</footer>